export class Accumulator {
    entryType: string;
    name: string;
    property: string;
    value: number;
    counter: number;
    constructor({
        entryType,
        name,
        property,
    }: {
        entryType: string;
        name: string;
        property: string;
    }) {
        Object.assign(this, {
            entryType,
            name,
            property,
            value: 0,
            counter: 0,
        });
        this.accumulate = this.accumulate.bind(this);
    }

    // Accumulate values from relevant entries
    accumulate(entry: PerformanceEntry): PerformanceEntry {
        if (entry.entryType === this.entryType) {
            this.value += Number.isNaN(entry[this.property])
                ? 0
                : entry[this.property];
            this.counter++;
        }

        return entry;
    }

    // Build the mark structure to report
    getMark(): PerformanceMark {
        return {
            counter: this.counter,
            entryType: "mark",
            name: this.name,
            startTime: this.value,
            _mergeable: true,
            metrics: undefined,
            target: undefined,
            user_action: undefined,
            detail: undefined,
            duration: undefined,
            toJSON: () => ({
                counter: this.counter,
                entryType: "mark",
                name: this.name,
                startTime: this.value,
                _mergeable: true,
            }),
        };
    }
}
